import menuService from '@/services/menu.service';
import commonService from '@/services/common.service';
import config from '@/config/prod.env';

const actions = {
    async getAllMenu({ dispatch }) {
        return await menuService.getAll();
    },

    async getAllPagingMenu({ dispatch }, params) {
        return await menuService.getAllPaging(params);
    },

    async getMenuByRoleId({ dispatch }, roleId) {
        return await menuService.getByRoleId(roleId);
    },

    async getMenuByRoleIds({ dispatch }, roleIds) {
        return await menuService.getByRoleIds(roleIds);
    },

    async getMenuByRolesAsTree({ dispatch }, roleIds) {
        return await menuService.getByRolesAsTree(roleIds);
    },
};

export const menu = {
    namespaced: true,
    actions
};